// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"921":"0bace509","984":"7e811480"}[chunkId] + ".js";
};